let pipelineHistoryCols = [
    {
        key: 'typeLabel',
        display: 'Type'
    },
    {
        key: 'makeLabel',
        display: 'Make'
    },
    {
        key: 'modelLabel',
        display: 'Model'
    },
    {
        key: 'imeiNo',
        display: 'IMEI'
    },
    {
        key: 'serialNo',
        display: 'Serial'
    },
    {
        key: 'pipelineLabel',
        display: 'Pipeline'
    },
    {
        key: 'runDateAsLocalTime',
        display: 'Run Date'
    },
    {
        key: 'passed',
        display: 'Passed'
    }
]

export { pipelineHistoryCols }